import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { GlobalState } from 'ha/types/store';
import { getCurrentPageLanguages } from 'ha/modules/LanguageSwitcher/selectors';

import { makeStyles } from 'tss-react/mui';
import { Container, Grid, units } from '@hbf/dsl';

import {
  AppLinks,
  AvailableLanguages,
  LandlordsLinks,
  SocialLinks,
  SupportLinks,
  TenantsLinks,
} from '../components';
import { NOFOLLOW_REF } from '../constants';

const useStyles = makeStyles()(theme => ({
  footer: {
    backgroundColor: theme.palette.grey[700],
    paddingTop: units.rem(3),
    paddingBottom: units.rem(1),
  },
}));

interface Props {
  noFollow?: boolean;
}

const Footer: React.FC<Props> = ({ noFollow }) => {
  const location = useLocation();
  const { classes } = useStyles();

  const rel = noFollow ? NOFOLLOW_REF : '';

  const getLanguages = React.useCallback(
    (state: GlobalState) => getCurrentPageLanguages(state, location),
    [location],
  );
  const availableLanguages = useSelector(getLanguages);

  return (
    <footer className={classes.footer} data-test-locator="Footer">
      <Container maxWidth="lg">
        <Grid
          container
          columns={{ xs: 1, md: 6 }}
          textAlign={{ xs: 'center', md: 'left' }}
        >
          <AvailableLanguages
            rel={rel}
            availableLanguages={availableLanguages}
          />
          <AppLinks rel={rel} />
          <TenantsLinks rel={rel} />
          <LandlordsLinks rel={rel} />
          <SupportLinks rel={rel} />
        </Grid>

        <SocialLinks />
      </Container>
    </footer>
  );
};

export { Footer };
